<template>
	<div class="youthlearn">
		<div class="top">
			<div class="l_c">
				<div class="title">青年大学习</div>
				<div class="line"></div>
			</div>
			<div class="r_c" @click="tomore">更多 ></div>
		</div>

		<div class="listcon">
			<!-- $util.goPage('newDetail',23,item.id) -->
			<div class="signle" v-for="(item,index) in list" :key="index" @click="openUrl(item)">
				<div class="imgcon">
					<img :src="imgs[index].src" />
				</div>
				<div class="title">{{item.title?item.title:''}}</div>
			</div>
		</div>

	</div>

</template>

<script>


export default {
  props:['list','sign'],
  data: function() {
		return {
		  imgs:[
			  {src:require('../../assets/img/party/studyimg1.jpg')},
			  {src:require('../../assets/img/party/studyimg2.jpg')},
			  {src:require('../../assets/img/party/studyimg3.jpg')},
			  {src:require('../../assets/img/party/studyimg4.jpg')},
			  {src:require('../../assets/img/party/studyimg5.jpg')},
			  {src:require('../../assets/img/party/studyimg6.jpg')},
		  ]
		};
  },

  mounted() {

  },

  methods: {
	  openUrl(item){
		  window.open(item.href)
	  },
		tomore(){
			this.$router.push({ path: '/jumppage/youthlist', query: {type:this.sign} });
		}

  },


};
</script>

<style scoped="scoped" lang="scss">

.youthlearn{

	.top{
		height: 35px;
		display: flex;
		justify-content: space-between;
		border-bottom: 2px solid #F1F1F1;
		.l_c{
			.title{
				font-size: 18px;
				font-weight: bold;
				color: #BA0711;
			}
			.line{
			   margin-top: 5px;
				width: 106px;
				height: 5px;
				background: #BA0711;
			}
		}
		.r_c{
			font-size: 14px;
			font-weight: 300;
			color: #BA0711;
			cursor: pointer;
		}

	}

	.listcon{
		display: flex;
		flex-wrap: wrap;
		margin-top: 20px;
		.signle{
			margin-top: 40px;
			margin-left: 20px;
			.imgcon{
				width: 366px;
				height: 202px;
				overflow: hidden;
				img{
					cursor: pointer;
					width: 100%;
				}
			}
			.title{
        width: 366px;
				cursor: pointer;
				height: 40px;
				line-height: 40px;
				font-size: 16px;
				font-weight: 400;
				padding: 0px 5px;
				color: #333333;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
			}
		}

		.signle:hover{
			transform: translateY(-10px);
			box-shadow:  5px 5px 8px rgba(0, 0, 0, 0.3);
		}
	}


}

</style>
